import React, { FC, Fragment, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Grid, RootRef, TextField, Typography } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import classNames from 'classnames';
import Clipboard from 'clipboard';

import { CreateApiTokenOutput } from 'api';
import { useNotify } from 'hooks';

import useStyles from './styles';

interface Props {
  token: CreateApiTokenOutput;
}

const NewKey: FC<Props> = ({ token }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const notify = useNotify();
  const clipboardInstance = useRef<Clipboard>(null);
  const textRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    initESClipboard();

    return () => {
      clipboardInstance.current?.destroy();
    };
  }, []);

  function initESClipboard() {
    clipboardInstance.current = new Clipboard(buttonRef.current, {
      target: () => textRef.current,
    });
    clipboardInstance.current.on('success', () => {
      notify.info({ i18n: { i18nKey: 'components:apiKeyCopied' } });
    });
  }

  return (
    <Fragment>
      <Grid container justify="space-between" alignItems="center" spacing={2}>
        <Grid item xs>
          <TextField fullWidth disabled label={t('components:keyName')} value={token.token_name} />
        </Grid>
        <Grid item>
          <div className={classes.placeholder} />
        </Grid>
      </Grid>
      <Box marginTop={2} />
      <Grid container justify="space-between" alignItems="center" spacing={2}>
        <Grid item xs>
          <TextField fullWidth label={t('components:key')} value={token.api_token} />
        </Grid>
        <Grid item>
          <span className={classes.copyText} ref={textRef}>
            {token.api_token}
          </span>
          <RootRef rootRef={buttonRef}>
            <Button
              className={classNames(classes.button, classes.copyButton, classes.altBlueButton)}
              size="large"
              variant="contained"
            >
              {t('common:copy')}
            </Button>
          </RootRef>
        </Grid>
      </Grid>
      <Box marginTop={2}>
        <Grid alignItems="center" container spacing={1}>
          <Grid item>
            <InfoOutlinedIcon color="disabled" />
          </Grid>
          <Grid item xs>
            <Typography gutterBottom color="textSecondary">
              {t('components:keyNameHelp')}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Fragment>
  );
};

export default NewKey;
